export const TYPE_EVENT = 'event';
export const TYPE_DEPARTMENT = 'department';
export const TYPE_COST_CENTER = 'costcenter';
